import Trend01VisualPng from './assets/Trend01Visual.png'
import Trend01VisualPng2x from './assets/Trend01Visual@2x.png'
import Trend01VisualWebp from './assets/Trend01Visual.webp'
import Trend01VisualWebp2x from './assets/Trend01Visual@2x.webp'

import Trend02VisualPng from './assets/Trend02Visual.png'
import Trend02VisualPng2x from './assets/Trend02Visual@2x.png'
import Trend02VisualWebp from './assets/Trend02Visual.webp'
import Trend02VisualWebp2x from './assets/Trend02Visual@2x.webp'

import Trend03VisualPng from './assets/Trend03Visual.png'
import Trend03VisualPng2x from './assets/Trend03Visual@2x.png'
import Trend03VisualWebp from './assets/Trend03Visual.webp'
import Trend03VisualWebp2x from './assets/Trend03Visual@2x.webp'

import Trend04VisualPng from './assets/Trend04Visual.png'
import Trend04VisualPng2x from './assets/Trend04Visual@2x.png'
import Trend04VisualWebp from './assets/Trend04Visual.webp'
import Trend04VisualWebp2x from './assets/Trend04Visual@2x.webp'

import Trend05VisualPng from './assets/Trend05Visual.png'
import Trend05VisualPng2x from './assets/Trend05Visual@2x.png'
import Trend05VisualWebp from './assets/Trend05Visual.webp'
import Trend05VisualWebp2x from './assets/Trend05Visual@2x.webp'

export const trends = [
  {
    order: `01`,
    heading: `Personalization and ROI go hand in hand`,
    caption: `Nearly half (49%) of consumers say they will likely become a repeat buyer after a personalized shopping experience with a retailer.`,
    pngSrc: Trend01VisualPng,
    pngSrc2x: Trend01VisualPng2x,
    webpSrc: Trend01VisualWebp,
    webpSrc2x: Trend01VisualWebp2x,
  },
  {
    order: `02`,
    heading: `Investments in omnichannel are improving, but still have a long way to go`,
    caption: `Only 35% of companies feel they are successfully achieving omnichannel personalization, up from 24% in 2021.`,
    pngSrc: Trend02VisualPng,
    pngSrc2x: Trend02VisualPng2x,
    webpSrc: Trend02VisualWebp,
    webpSrc2x: Trend02VisualWebp2x,
  },
  {
    order: `03`,
    heading: `Businesses are future-proofing their personalization efforts with first-party data`,
    caption: `37% of brands exclusively use first-party data to personalize customer experiences, a six percentage point increase compared to 2021.`,
    pngSrc: Trend03VisualPng,
    pngSrc2x: Trend03VisualPng2x,
    webpSrc: Trend03VisualWebp,
    webpSrc2x: Trend03VisualWebp2x,
  },
  {
    order: `04`,
    heading: `Businesses seek balance in the personalization-privacy paradox`,
    caption: `Just 40% of consumers say they trust brands to keep their personal data secure and use it responsibly.`,
    pngSrc: Trend04VisualPng,
    pngSrc2x: Trend04VisualPng2x,
    webpSrc: Trend04VisualWebp,
    webpSrc2x: Trend04VisualWebp2x,
  },
  {
    order: `05`,
    heading: `The bar for personalization is getting higher`,
    caption: `Less than half (47%) of companies personalize communications based on real-time customer behavior.`,
    pngSrc: Trend05VisualPng,
    pngSrc2x: Trend05VisualPng2x,
    webpSrc: Trend05VisualWebp,
    webpSrc2x: Trend05VisualWebp2x,
  },
]
